import { useState } from 'react';
import { toAppError } from '@/shared/api/errors';
import type { Draft } from '../api/draftsApi';
import { useApproveDraft, useRejectDraft } from './useDraftQueries';

/** Approve/reject wiring with a visible outcome for every action, success or failure. */
export function useDraftDecisions() {
  const approveMutation = useApproveDraft();
  const rejectMutation = useRejectDraft();
  const [rejecting, setRejecting] = useState<Draft | null>(null);
  const [toast, setToast] = useState<string | null>(null);

  const approve = (draft: Draft, text: string, listId: string) => {
    approveMutation.mutate(
      { id: draft.id, text, listId },
      {
        onSuccess: () => { setToast(`Approved. Sending ${draft.id} to WhatsApp.`); },
        onError: (err) => { setToast(`Could not approve ${draft.id}. ${toAppError(err).message}`); },
      },
    );
  };

  const reject = (reason: string) => {
    if (!rejecting) return;
    const draft = rejecting;
    rejectMutation.mutate(
      { id: draft.id, reason },
      {
        onSuccess: () => { setToast(`Rejected. ${draft.requester.name} has been told why.`); setRejecting(null); },
        onError: (err) => { setToast(`Could not reject ${draft.id}. ${toAppError(err).message}`); },
      },
    );
  };

  return {
    approve,
    reject,
    rejecting,
    startReject: setRejecting,
    cancelReject: () => { setRejecting(null); },
    isBusy: approveMutation.isPending || rejectMutation.isPending,
    isRejectPending: rejectMutation.isPending,
    toast,
    clearToast: () => { setToast(null); },
  };
}
